var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirEyeSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.833C5.5 4.16634 14.5 4.16634 17.5 10.833",
    stroke: "#292D32",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.166C9.6717 14.166 9.34661 14.1014 9.04329 13.9757C8.73998 13.8501 8.46438 13.6659 8.23223 13.4338C8.00009 13.2016 7.81594 12.926 7.6903 12.6227C7.56466 12.3194 7.5 11.9943 7.5 11.666C7.5 11.3377 7.56466 11.0126 7.6903 10.7093C7.81594 10.406 8.00009 10.1304 8.23223 9.89825C8.46438 9.6661 8.73998 9.48195 9.04329 9.35632C9.34661 9.23068 9.6717 9.16602 10 9.16602C10.663 9.16602 11.2989 9.42941 11.7678 9.89825C12.2366 10.3671 12.5 11.003 12.5 11.666C12.5 12.3291 12.2366 12.9649 11.7678 13.4338C11.2989 13.9026 10.663 14.166 10 14.166Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirEyeSolid);
export default __webpack_public_path__ + "static/media/iconoir_eye-solid.474ace08360be3f10a62476e5d083734.svg";
export { ForwardRef as ReactComponent };